(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-announcement"] && !Shopify.designMode) return;
  try {
    
  class PromoAnnouncementSlider extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('.promo-announcement-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.promo-announcement-slider__dot'));
      this.prevButton = this.querySelector('[data-direction="prev"]');
      this.nextButton = this.querySelector('[data-direction="next"]');
      this.viewport = this.querySelector('[data-viewport]');
      this.currentIndex = 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (Number(this.dataset.speed) || 5) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.touchStartX = 0;
      this.desktopQuery = window.matchMedia('(min-width: 750px)');

      if (!this.track || !this.slides.length) return;

      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1, true));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1, true));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.slideIndex), true);
        });
      });

      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.pauseAutoplay());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.startAutoplay();
      });

      this.desktopQuery.addEventListener('change', () => this.applyLayout());
      this.bindSwipe();
      this.applyLayout();

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.promo-announcement-slider__slide');
          if (slide && this.contains(slide)) {
            this.goTo(Number(slide.dataset.slideIndex), true);
          }
        });
      }
    }

    isDesktop() {
      return this.desktopQuery.matches;
    }

    applyLayout() {
      if (this.isDesktop()) {
        this.pauseAutoplay();
        this.track.style.transform = 'none';
        this.slides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
        return;
      }

      this.goTo(this.currentIndex, false);
      this.startAutoplay();
    }

    bindSwipe() {
      if (!this.viewport) return;

      this.viewport.addEventListener(
        'touchstart',
        (event) => {
          this.touchStartX = event.changedTouches[0].screenX;
          this.pauseAutoplay();
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchend',
        (event) => {
          const diff = event.changedTouches[0].screenX - this.touchStartX;
          if (Math.abs(diff) > 40) {
            this.goTo(this.currentIndex + (diff < 0 ? 1 : -1), true);
          } else {
            this.startAutoplay();
          }
        },
        { passive: true }
      );
    }

    goTo(index, userTriggered) {
      const total = this.slides.length;
      if (!total) return;

      if (this.isDesktop()) {
        this.applyLayout();
        return;
      }

      this.currentIndex = ((index % total) + total) % total;
      this.track.style.transform = 'translate3d(-' + this.currentIndex * 100 + '%, 0, 0)';

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.currentIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (userTriggered) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.pauseAutoplay();
      if (this.isDesktop() || !this.autoplayEnabled || this.reducedMotion || this.slides.length < 2) return;
      this.autoplayTimer = window.setInterval(() => {
        this.goTo(this.currentIndex + 1, false);
      }, this.autoplaySpeed);
    }

    pauseAutoplay() {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  if (!customElements.get('promo-announcement-slider')) {
    customElements.define('promo-announcement-slider', PromoAnnouncementSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
